import type { SVGProps } from "react";

// Private copy of root SDK's BinIcon (src/app/ui/components/BinIcon.tsx),
// kept in sync manually; packages/ must not import from the root SDK.
type BinIconProps = SVGProps<SVGSVGElement> & { alt?: string };

export default function BinIcon(props: BinIconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g>
        <path d="M6.325 21.6254C5.6548 21.6254 5.09142 21.3996 4.63485 20.9479C4.17828 20.4962 3.95 19.9387 3.95 19.2754V5.45039H2.5V3.10039H8.275V1.90039H15.7V3.10039H21.5V5.45039H20.05V19.2754C20.05 19.9262 19.8186 20.4806 19.3558 20.9385C18.893 21.3964 18.3327 21.6254 17.675 21.6254H6.325ZM17.675 5.45039H6.325V19.2754H17.675V5.45039ZM8.85 17.3254H10.775V7.35039H8.85V17.3254ZM13.225 17.3254H15.175V7.35039H13.225V17.3254Z" />
      </g>
    </svg>
  );
}
